import React, { ReactNode } from 'react';
import { Popover as MaterialPopover, PopoverProps as MaterialPopoverProps } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import { BOX_SHADOW } from '~/Constants/CSS.constants';
import cn from 'classnames';

interface PopoverProps extends MaterialPopoverProps {
  children: ReactNode;
  anchorEl?: null | Element | ((element: Element) => Element);
  arrowLeft?: boolean;
  width?: number | string;
  contentClasses?: Object;
}

const useStyles = (width: number | string, extraContentClasses = {}) =>
  makeStyles(() => ({
    paper: {
      overflowX: 'unset',
      overflowY: 'unset',
      // Arrow
      '&::before': {
        // content: '""',
        position: 'absolute',
        marginRight: '-0.71em',
        bottom: 0,
        left: 0,
        top: 'calc(50% - 10px)',
        width: 10,
        height: 10,
        backgroundColor: '#fff',
        boxShadow: BOX_SHADOW,
        transform: 'translate(-50%, 50%) rotate(-135deg)',
        clipPath: 'polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))',
      },
    },
    popoverContent: {
      maxHeight: 400,
      maxWidth: width,
      minWidth: width,
      overflowY: 'auto',
    },
    extraClasses: extraContentClasses,
  }));

export const Popover = ({
  arrowLeft,
  children,
  classes,
  width,
  contentClasses,
  ...rest
}: PopoverProps) => {
  const { classes: styles } = useStyles(width || 600, contentClasses)();

  return (
    <MaterialPopover
      classes={{
        ...(classes || {}),
        paper: `${classes?.paper} ${arrowLeft ? styles.paper : ''}`,
      }}
      {...rest}
    >
      <div className={cn(styles.popoverContent, styles.extraClasses)}>{children}</div>
    </MaterialPopover>
  );
};
